<span>{{messagePartA}}</span>
<span *ngIf="!isMaster && !isPartner">...</span>
<span *ngIf="isMaster">{{messageRoleMaster}}</span>
<span *ngIf="isPartner">{{messageRolePartner}}</span>
<span>{{messagePartB}}</span>